import { render, staticRenderFns } from "./DialogKosten.vue?vue&type=template&id=accadeda&scoped=true"
import script from "./DialogKosten.vue?vue&type=script&lang=ts"
export * from "./DialogKosten.vue?vue&type=script&lang=ts"
import style0 from "./DialogKosten.vue?vue&type=style&index=0&id=accadeda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "accadeda",
  null
  
)

export default component.exports